export const PrimaryColour = '#FAD578';
export const SecondaryColour = '#965792';
